module.exports = __webpack_public_path__ + "static/media/1-month-CN.dd180342.png";